import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Services {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  ServicesData?: any;
}

const initialState: Services = {
  isLoading: false,
  error: false,
  message: null,
  ServicesData: [],
};

const UserServicesSlice = createSlice({
  name: "Services",
  initialState,
  reducers: {
    loadingServices: (state: Services, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setServices: (state: any, action: PayloadAction<Services>) => {
      return action.payload;
    },
    clearUserServiceData: (state: Services, action: PayloadAction) => {
      state.error = false;
      state.isLoading = false;
      state.message = null;
      state.ServicesData = [];
    },
  },
});

export const { loadingServices, setServices, clearUserServiceData } =
  UserServicesSlice.actions;

export default UserServicesSlice.reducer;
